<style>
.post-update > label.ivu-radio-wrapper.ivu-radio-group-item {
  display: flex;
  justify-content: space-between;
  /* flex-direction: row-reverse; */
  align-items: center;
  border-top: 1px solid #eee;
  padding-top: 10px;
}

.post-update:first-child > label.ivu-radio-wrapper.ivu-radio-group-item {
  border-top: 0;
  padding-top: 0;
}
.ivu-radio-group {
  width: 100%;
}
.ivu-modal-body {
  overflow: auto;
}
</style>

<style lang="scss">
.post-update {
    .ivu-radio {
      display: none !important;
    }
}
</style>


<template>
   <div class="post-update-modal-component">
      <Modal :closable="false"  v-model="showModal" @on-cancel="onCancel()" :transfer="false" :styles="{top: '60px'}">
         <!-- <p slot="header" style="color:#333;text-align:center">
            <span>Post Update</span>
         </p> -->
        <div slot="header" class="flex-container direction-row center" style="justify-content:space-between;height:15px;">
          <div class="order-1"></div>
          <b class="order-2">Post Update</b>
          <div class="order-3"></div>
          <img alt=" " @click="onCancel()" style="height:25px; width:25px;position:absolute;top:0;right:0;margin:10px 10px 0 0;" src="@/assets/close.png">
        </div>
        <div v-if="permittedPlans.isLoading" style="text-align: center;">
          <i class="fa fa-spin fa-spinner" />
        </div>
        <div style="max-height:57vh" v-if="isAuthenticated && userInfo && userInfo.user_type !== 'guest'">
          <RadioGroup v-model="planHolder">
            <span style="margin-bottom: 20px; font-size: small;">
              Timeline
            </span>
              <p style="margin-bottom:10px" v-on:click="onProceedCareplan('journal_public')"
              class="post-update">
                <Radio label="Timeline">
                    <div style="display: flex;">
                      <Avatar v-if="userInfo" style="border:1px solid #ddd;padding:3px;width: 55px; height: 55px;" shape="square" :src="userDisplayImage(userInfo)" />&nbsp;
                      <div style="display: flex; flex-direction: column; margin-left: 10px;">
                        <span style="line-height: 20px;">
                          Timeline - public posts
                        </span>
                        <small class="truncate">
                          Visible on your profile's Timeline
                        </small>
                      </div>
                    </div>
                </Radio>
              </p>
              <p style="margin-bottom:10px" class="post-update">
                <Radio label="Timeline">
                    <div style="display: flex; flex-direction: column;">
                      <div style="display: flex;" v-on:click="onProceedCareplan('journal_private')">
                        <Avatar v-if="userInfo" style="border:1px solid #ddd;padding:3px;width: 55px; height: 55px;" size="large" shape="square" :src="userDisplayImage(userInfo)" />&nbsp;
                        <div style="display: flex; flex-direction: column; margin-left: 10px;">
                          <span style="line-height: 20px;">
                            My Team - private posts
                          </span>
                          <small class="truncate">
                            Visible on My Team
                          </small>
                        </div>
                      </div>
                      <CareTeam style="margin-top: -10px; margin-left: 65px;" :hideControl="true" :user="userInfo" :isCurrentUser="true" @showProfile="closePostSelection" />
                    </div>
                </Radio>
              </p>
            <span v-if="permittedPlans.list.data && permittedPlans.list.data.length > 0" style="margin-bottom: 20px; font-size: small;">
              Groups
            </span>
              <p v-for="(plan, pkey) in permittedPlans.list.data"
                v-if="plan.type !== 'nearby'"
                :key="pkey" style="margin-bottom:10px"
                v-on:click="onProceedCareplan(plan)" class="post-update">
                <Radio :label="plan.title">
                    <div>
                      <Avatar v-if="plan && plan.thumbnail_photo" style="border:1px solid #ddd;padding:3px" shape="square" :src="planDisplayImage(plan)" />&nbsp;
                      {{plan.title}}
                    </div>
                </Radio>
              </p>
          </RadioGroup>
        </div>
        <div slot="footer">
               <!-- <Button size="large" long v-on:click="onProceed">Proceed</Button> -->
        </div>
      </Modal>
   </div>
</template>

<script>
import Utils from '@/utils.js'
import VueCookie from 'vue-cookie'
import Cons from '@/constants.json'

import CareTeam from '@/components/CareTeam';

export default {
  name: 'PostUpdateModalComponent',
  components: {
    CareTeam
  },
  computed: {
    isAuthenticated() {
      return ( localStorage.getItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE') ) ? true:false;
    },
    showModal: {
      get () {
        return this.$store.state.menu.postSelectionDialogShow
      },
      set (val) {
        // this.modalSetter = val
        this.$store.commit("menu/setPostSelectionModal", val)
      }
    },
    permittedPlans: {
      get () {
        return this.$store.state.menu.permitted
      }
    },
    userInfo: {
      get () {
        return this.$store.state.user.info
      }
    }
  },
  watch: {
    showModal: function(n,o) {
      console.log(n, this.userInfo)
      if (n) this.$store.dispatch("menu/getPermittedPlan")
    }
  },
  data () {
    return {
      modalSetter: false,
      selectedCareplan: 'journal',
      planHolder: 'Timeline',
    }
  },
  methods: {
    onCancel () {
      this.$store.commit('menu/setPostSelectionModal', false)
      this.$store.commit('menu/setTriggerPostSelection', false)
    },
    onProceed () {
      this.$emit('emitProceed', this.selectedCareplan)
    },
    onProceedCareplan (v) {
      this.$emit('emitProceed', v)
    },
    userDisplayImage(user) {
      return Utils.getDisplayImage('user', user, 'small')
    },
    planDisplayImage(plan) {
      return Utils.getDisplayImage('group', plan, 'small')
    },
    closePostSelection() {
      this.$store.commit("menu/setPostSelectionModal", false);
    }
  }
}
</script>
